
import { MinimalVersion } from '../../interfaces/MFE/IMicrofront'
import { filesystem } from '../init'

export default async function readModulesFromDevice (): Promise<MinimalVersion[]> {

  const modulesInMemory: MinimalVersion[] = []
  if ( filesystem !== undefined ){
    const modules = await filesystem.list( filesystem.getPath( 'modules' ) )
    for ( let i = 0; i < modules.files.length; i++ ){
      const versions = await filesystem.list( filesystem.getPath( 'modules', { mfe_id: modules.files[ i ].name } ) )
      for ( let j = 0; j < versions.files.length; j++ ){
        const versionFiles = await filesystem.list( filesystem.getPath( 'modules', { mfe_id: modules.files[ i ].name, mfe_version: versions.files[ j ].name } ) )
        if ( versionFiles.files.length > 2 ) {
          modulesInMemory.push({ mfe_id: modules.files[ i ].name, version: versions.files[ j ].name })
        }
      }
    }
  }
  return modulesInMemory
}
